<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-toolbar flat>
                <v-toolbar-title>Hasil Produksi</v-toolbar-title>
                <v-divider class="mx-4" inset vertical />
                <v-spacer />
            </v-toolbar>
            <div class="mt-3">
                <!-- <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Produksi</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="date" prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="date"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row> -->
                <v-row class="mx-5">
                    <v-col cols="1">Delivery</v-col>
                    <v-col cols="2">
                        <v-menu v-model="dateDeliveryMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="dateDelivery" prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateDelivery"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="1">Volume</v-col>
                    <v-col cols="2">
                        <v-select outlined dense hide-details="auto" :items="volumes" item-value="code" item-text="description" v-model="selectedVolume"></v-select>
                    </v-col>
                    <v-col cols="1">
                        <v-btn depressed color="primary" @click="getData" class="me-2">Get Data</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-5">
                    <v-card outlined>
                        <v-simple-table class="spreadsheet-table flex-table" fixed-header height="440" ref="tableKoordinator">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="header-cell">No</th>
                                        <th class="header-cell">Kode Produk</th>
                                        <th class="header-cell">Nama Produk</th>
                                        <th class="header-cell text-center">Produksi</th>
                                        <th class="header-cell"></th>
                                        <th class="header-cell text-center" v-for="(coor, ic) in coordinators" :key="ic">
                                            {{ coor.name }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="isLoading">
                                        <tr v-for="n in 10" :key="n">
                                            <td><v-skeleton-loader type="text" /></td>
                                            <td><v-skeleton-loader type="text" /></td>
                                            <td><v-skeleton-loader type="text" /></td>
                                            <td><v-skeleton-loader type="text" /></td>
                                            <td><v-skeleton-loader type="text" /></td>

                                            <td class="spreadsheet-cell" v-for="(coor, ic) in coordinators" :key="ic">
                                                <v-skeleton-loader type="text" />
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr v-for="(row, idx) in items" :key="idx">
                                            <td class="header-cell">{{ idx + 1 }}</td>
                                            <td class="header-cell text-no-wrap">{{ row.product_code }}</td>
                                            <td class="header-cell text-no-wrap">{{ row.product_name }}</td>
                                            <td class="spreadsheet-cell text-center">
                                                <v-text-field v-model="row.qty_produced" class="disable2-input" type="number" readonly solo hide-details />
                                                <span style="display: none;">{{ row.qty_produced }}</span>
                                            </td>
                                            <td class="header-cell text-center"></td>

                                            <td class="spreadsheet-cell" v-for="(coor, ic) in coordinators" :key="ic">
                                                <v-text-field :value="calculateCoor(row, coor)" class="disable2-input" type="number" readonly solo hide-details />
                                                <span style="display: none;">{{ calculateCoor(row, coor) }}</span>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th class="header-cell text-right" colspan="3">TOTAL PRODUKSI</th>
                                        <th class="header-cell text-center">
                                            {{ totalQty }}
                                        </th>
                                        <th class="header-cell text-center"></th>
                                        <th class="header-cell text-center" v-for="(coor, ic) in coordinators" :key="ic">
                                            {{ totalQtyByCoor(coor) }}
                                        </th>
                                    </tr>
                                </tfoot>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-row>
            </div>
            <v-card-actions class="pr-4 mt-3 mx-5">
                <v-spacer />
                <v-btn depressed color="green" class="d-inline ms-2 white--text" @click="export2xls">Export to XLS</v-btn>
                <!-- <v-btn depressed color="primary" @click="saveData" class="px-6">
                    Save
                </v-btn> -->
            </v-card-actions>
        </v-card>
        <v-overlay :value="saveProgress" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
// import moment from 'moment';
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data() {
        return {
            valid: true,
            isLoading: false,
            saveProgress: false,
            date: '',
            dateDelivery: '',
            dateMenu: false,
            dateDeliveryMenu: false,
            coordinators: [],
            volumes: [],
            selectedVolume: '250',
            items: [],
            item_coordinators: [],
            items_kcic: [],
        }
    },

    async created() {
        this.coordinators = (await this.$store.dispatch('coordinator/getObjs')).data.data;

        // this.date = moment().format('YYYY-MM-DD');
        this.getVolumes();

        // this.fetchData();
    },

    computed: {
        totalCoordinator() {
            return this.coordinators.filter(coor => !coor.is_special).length;
        },
        totalQty() {
            return this.items.reduce((sum, item) => sum + Number(item.qty_produced), 0);
        },
        totalQtyReduced() {
            return this.items.reduce((sum, item) => sum + Number(item.qty_reduced), 0);
        },
        totalQtyActual() {
            return this.items.reduce((sum, item) => sum + this.calculateQtyActual(item), 0);
        },
        listCoordinator() {
            return this.coordinators.filter(i => !i.is_special).sort((a, b) => a.sort_no - b.sort_no);
        }
    },

    methods: {
        getVolumes() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.volumes = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        setDate() {
            this.fetchData();
        },
        handleChangeVolume() {
            this.fetchData();
        },
        getData() {
            this.fetchData()
        },
        async fetchData() {
            this.isLoading = true;

            try {
                const data = (await this.$store.dispatch('coordinatorproduction/getData', {
                    size: this.selectedVolume,
                    // date: this.date,
                    delivery_date: this.dateDelivery,
                }));

                this.items = data.items;

                this.item_coordinators = data.item_coordinators;
                // this.items_kcic = data.items_kcic;

                this.dateDelivery = data.delivery_date;
            } catch (error) {
                console.error('Error fetching finalisasi produksi:', error);
            } finally {
                this.isLoading = false;
            }
        },
        calculateQtyActual(item) {
            return parseInt(item.qty_produced);
        },
        calculateCoor(item, coordinator) {
            let itemCoordinator = this.item_coordinators.find(i => 
                i.product_code === item.product_code &&
                i.coordinator_code === coordinator.code);

            if (itemCoordinator) {
                return itemCoordinator.quantity_awal;
            } else {
                return 0;
            }

            // if (coordinator.is_special) {
            //     return this.calculateQtyKcic(item);
            // }

            // const qtyActual = item.qty_produced;
            // const qtyKcic = this.calculateQtyKcic(item);

            // const currentIndex = this.coordinators.findIndex(c => c.code === coordinator.code);
            // if (currentIndex === -1) return 0;

            // let qty;

            // if (currentIndex === 0) {
            //     qty = Math.round(qtyActual / this.totalCoordinator);
            // } else {
            //     let used = 0;
            //     for (let i = 0; i < currentIndex; i++) {
            //         used += this.calculateCoor(item, this.coordinators[i]);
            //     }
            //     qty = qtyActual - used - qtyKcic;
            // }

            // let itemCoordinator = this.item_coordinators.find(i => 
            //     i.product_code === item.product_code &&
            //     i.coordinator_code === coordinator.code);

            // if (itemCoordinator) {
            //     itemCoordinator.quantity_awal = qty;
            //     return itemCoordinator.quantity_awal;
            // } else {
            //     return 0;
            // }
        },
        calculateQtyKcic(item) {
            let itemKcic = this.items_kcic.find(i => i.product_code === item.product_code);
            if (itemKcic) {
                return itemKcic.quantity;
            } else {
                return 0;
            }
        },
        totalQtyByCoor(coordinator) {
            return this.item_coordinators
                .filter(i => i.coordinator_code === coordinator.code)
                .reduce((sum, i) => sum + Number(i.quantity_awal), 0);
        },
        async saveData() {
            this.saveProgress = true;

            try {
                const result = await this.$store.dispatch('coordinatorproduction/save', {
                    production_date: this.date,
                    delivery_date: this.dateDelivery,
                    items: this.item_coordinators,
                });

                if (result.status == 200 || result.status == 201) {
                    this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Data berhasil disimpan'});
                } else {
                    this.$store.commit('setSnackbar', {saveError: true, errorMessage: 'Error'});
                }
            } catch (error) {
                console.log('Error save koordinasi produksi:', error);
                this.$store.commit('setSnackbar', {saveError: true, errorMessage: error.response.data.message});
            } finally {
                this.saveProgress = false;
            }
        },
        export2xls() {
            const wb = utils.table_to_book(this.$refs.tableKoordinator.$el.firstChild.firstChild);
            writeFileXLSX(wb, "Koordinator-Produksi.xlsx");
        }

    }
}
</script>

<style scoped>
.spreadsheet-table {
  border-collapse: collapse;
  width: 100%;
}

.header-cell,
.spreadsheet-cell {
  border: 1px solid #ddd;
  padding: 8px !important;
  text-align: left;
  min-width: 100px;
}

.spreadsheet-cell {
  background-color: #f9f9f9;
  cursor: pointer;
  padding: 0px !important;
}

.spreadsheet-cell:focus-within {
  background-color: #e6f7ff;
  outline: none;
}

.spreadsheet-input {
  padding: 0 !important;
  margin: 0;
  border: none;
  box-shadow: none;
  /* background-color: transparent !important; */
  background-color: yellow !important;
  font-size: inherit;
  width: 100%;
}

.spreadsheet-input input {
  padding: 0 !important;
  border: none;
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__slot {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control input {
  background-color: #ffe169 !important;
  text-align: center;
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}

.small-select {
  height: 40px; /* Adjust the height of the component */
}
.small-select .v-input__control {
  min-height: 40px;
  line-height: 40px;
}
</style>